function trimSlashes(value) {
    return String(value || '').replace(/^\/+|\/+$/g, '');
}

function joinBaseAndKey(baseUrl, key) {
    if (!baseUrl || !key) return '';
    const base = String(baseUrl).replace(/\/+$/g, '');
    const cleanKey = trimSlashes(key);
    if (!cleanKey) return '';
    return `${base}/${cleanKey}`;
}

/**
 * Build S3 URL from key and visibility.
 *
 * @param key S3 object key.
 * @param visibility Only supports: "public" or "private".
 * @param options
 * @param options.concatPublic If true, always use public base URL.
 * @param options.concatPrivate If true, always use private base URL.
 */
export function buildS3UrlFromKey(
    key,
    visibility,
    publicOrPrivate
) {
    const safeKey = key != null ? String(key) : '';
    if (!safeKey) return '';

    console.log('key',  key,
        visibility,
        publicOrPrivate  );

    const publicBase = process.env.REACT_APP_PUBLIC_S3_URL;
    const privateBase = process.env.REACT_APP_PRIVATE_S3_URL;
    
    // Forced mode: ignore visibility when any concat option is explicitly enabled.
    if (publicOrPrivate?.concatPublic) return joinBaseAndKey(publicBase, safeKey);
    if (publicOrPrivate?.concatPrivate) return joinBaseAndKey(privateBase, safeKey);

    const v = String(visibility || '').toLowerCase();
    if (v === 'public') return joinBaseAndKey(publicBase, safeKey);
    if (v === 'private') return joinBaseAndKey(privateBase, safeKey);

    return '';
}
